import React, { useState, useEffect } from 'react';
import {
  Box, Chip, Modal,
  Typography,
  Button,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  TextField,
  Rating,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell, LinearProgress,
  TableBody,
  FormControlLabel,
  Checkbox, Pagination,
  Card, Snackbar, Alert
} from '@mui/material';
import {
  Send,
  Close,
  Add,
  Assessment,
  Star,
  Comment,
  TrendingUp,
  WorkspacePremium,
  Info,
  CloudUpload,
  InsertDriveFile,
  Assignment,
  Code,
  AccessTime,
  School,
  Business,
  CheckCircleOutline,
  Person,
  ThumbUpAlt,
} from '@mui/icons-material';
import { motion } from 'framer-motion';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import CodeIcon from '@mui/icons-material/Code';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import GroupIcon from '@mui/icons-material/Group';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { CheckCircleRounded } from '@mui/icons-material';
import PerfomanceRatingsAndFeedBack from './PerfomanceRatingsAndFeedBack';
import GoalDetails from '../../../components/GoalDetails';
import axios from "axios";
import { axiosInstance, localAxiosGet } from "../../../Axios/axios";
import TokenExpirePopup
  from "../../../components/TokenExpirePopup";
import AddGoal from '../../../components/AddGoal';

const statusColors = {
  Pending: '#f44336',              // 🔴 Red
  'In Progress': '#1976d2',        // 🔵 Blue
  Completed: '#4caf50',            // ✅ Green
  'Submitted For Review': '#ffb300' // 🟠 Amber
};

const statusTextColors = {
  Pending: '#fff',                // White text on red
  'In Progress': '#fff',          // White text on blue
  Completed: '#fff',              // White text on green
  'Submitted For Review': '#fff'  // Black text on amber
};



const EmployeeApparisals = () => {

  const [loading, setLoading] = useState(false);
  const [openRequestDialog, setOpenRequestDialog] = useState(false);
  const [goalActiveStep, setGoalActiveStep] = useState(0)
  const [activeStep, setActiveStep] = useState(0);
  const [requestFormData, setRequestFormData] = useState({
    goalType: '',
    goalSubType: '',
    selectedPredefinedGoal: '',
    selectedPersonalGoals: [],
    timePeriod: '',
    objectiveTitle: '',
    description: '',
    requestType: '',
    projectName: '',
    taskName: '',
    startDate: '',
    endDate: '',
    weeklyGoals: [],
    toolsLearned: [],
    newToolName: '',
    newToolProficiency: 3,
    comments: '',
    files: [],
    improvementCategories: [],
    personalGrowthCategories: [],
  });
  const [showImprovementCategories, setShowImprovementCategories] = useState(false);
  const [isGoalsDetailsModalOpen, setIsgoalsDetailsModalOpen] = useState(false);
  const [selectedGoal, setSelectedGoal] = useState('')
  const [openTokenExpirePopup, setOpenTokenExpirePopup] = useState(false);
  const [goalSummaryApi, setGoalSummaryApi] = useState([]);
  const [allEmployeeGoals, setAllEmployeeGoals] = useState([]);
  const [rowsPerPage, setRowsperPage] = useState(5)
  const [pagination, setPagination] = useState({
    totalPages: 0,
    limit: rowsPerPage,
    currentPage: 1,
    totalGoals: 0
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const emp_id = localStorage.getItem('userId');
 


  useEffect(() => {

  
      getAllGoalsSummary();
      getAllGoalsForEmployee({ page: 1, limit: rowsPerPage });
    
  }, []);



  const getAllGoalsSummary = async () => {
    try {
      const response = await axiosInstance(
        localAxiosGet(`/empGoal/total_goal_count?emp_id=${emp_id}`)
      );

      if (response.data.status === "SUCCESS") {
        const apiData = response.data.result;

        const dataMapping = {
          totalGoals: {
            title: "Total Goals",
            icon: <Assessment sx={{ color: "#673AB7", fontSize: 40 }} />,
            bg: "linear-gradient(to right, #EDE7F6, #D1C4E9)",
            progressColor: "#673AB7",
          },
          businessGoals: {
            title: "Business Goals",
            icon: <Business sx={{ color: "#1976D2", fontSize: 40 }} />,
            bg: "linear-gradient(to right, #F3E5F5, #E1BEE7)",
            progressColor: "#1976D2",
          },
          personalGoals: {
            title: "Personal Goals",
            icon: <Person sx={{ color: "#FF9800", fontSize: 40 }} />,
            bg: "linear-gradient(to right, #FFF3E0, #FFE0B2)",
            progressColor: "#FF9800",
          },
        };

        const transformedData = apiData.map((item, index) => ({
          id: index + 1,
          ...dataMapping[item.type],
          value: item.totalCount,
          completed: item.completedCount,
          calculatedPercentage: item.completionPercentage,
        }));

        setGoalSummaryApi(transformedData);
      }
    } catch (error) {
      console.error("Error fetching goals:", error.response?.data || error.message);
      // if (error.response?.status === 403) {
      //   setOpenTokenExpirePopup(true);
      // }
    }
  };

  const getAllGoalsForEmployee = async ({ page = pagination.currentPage, limit = rowsPerPage }) => {

    try {
      const response = await axiosInstance(localAxiosGet(`empGoal/get_All_goals_by_emp_id?emp_id=${emp_id}&page=${page}&limit=${limit}`));
      if (response.data.status === 'SUCCESS') {
        setAllEmployeeGoals(response.data.result.goals);
        setPagination({
          totalPages: response.data.result.totalPages,
          currentPage: response.data.result.currentPage,
          totalGoals: response.data.result.totalGoals,
          limit: limit
        })

      }
    } catch (error) {
      console.error('Error in fetching the employee goals', error);
      setSnackbar({
        open: true,
        message: 'Error in fetching the employee all goals',
        severity: 'error'
      })
    }
  }


  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  const handleOpenRequestDialog = () => {
    setGoalActiveStep(0);
    setActiveStep(0);
    setOpenRequestDialog(true);
  };

  const handleGoalsDetailsClick = (goalId) => {
    setIsgoalsDetailsModalOpen(true);
    setSelectedGoal(goalId)
  }


  const handleCloseRequestDialog = () => {
    setOpenRequestDialog(false);
    resetFormData();
  };

  const resetFormData = () => {
    setRequestFormData({
      goalType: '',
      goalSubType: '',
      selectedPredefinedGoal: '',
      selectedPersonalGoals: [],
      timePeriod: '',
      objectiveTitle: '',
      description: '',
      requestType: '',
      projectName: '',
      taskName: '',
      startDate: '',
      endDate: '',
      weeklyGoals: [],
      toolsLearned: [],
      newToolName: '',
      newToolProficiency: 3,
      comments: '',
      files: [],
      improvementCategories: [],
      personalGrowthCategories: [],
    });
    setShowImprovementCategories(false);
    setGoalActiveStep(0);
    setActiveStep(0);
  };



  // 👉 Rows per page change
  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsperPage(newRowsPerPage);
    setPagination(prev => ({
      ...prev,
      limit: newRowsPerPage,
      currentPage: 1,   // ✅ reset to first page
    }));

    getAllGoalsForEmployee({ page: 1, limit: newRowsPerPage });
  };

  // 👉 Pagination change
  const handlePaginationChange = async (event, page) => {
    setPagination(prev => ({
      ...prev,
      currentPage: page,
    }));

    getAllGoalsForEmployee({ page: page, limit: pagination.limit });
  };


  const formatDate = (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };


  return (
    <Box sx={{ p: 3 }}>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
          <Typography variant="h4" fontWeight="bold">
            My Performance
          </Typography>
          <Box display="flex" alignItems="center" gap={2}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<Add />}
              onClick={handleOpenRequestDialog}
            >
              Add Goals
            </Button>

          </Box>
        </Box>

        {/* Goals Summary Cards Display */}
        <Box sx={{ mb: 12 }}>
          <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
            Goal Summary
          </Typography>

          <Grid container spacing={3}>
            {goalSummaryApi.map((goalData) => {
              const calculatedPercentage =
                goalData.completed !== undefined && goalData.value > 0
                  ? Math.round((goalData.completed / goalData.value) * 100)
                  : 0;

              return (
                <Grid item xs={12} sm={6} md={4} key={goalData.id}>
                  <Paper
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      boxShadow: 3,
                      background: goalData.bg,
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      transition: "transform 0.3s ease-in-out",
                      "&:hover": {
                        transform: "scale(1.03)",
                        boxShadow: `0px 6px 16px ${goalData.progressColor}55`,
                      },
                    }}
                  >
                    <Box sx={{ mb: 1.5 }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mb: 1,
                        }}
                      >
                        <Typography variant="h6" fontWeight="bold">
                          {goalData.title}
                        </Typography>
                        {goalData.icon}
                      </Box>
                      <Typography
                        variant="h4"
                        fontWeight="bold"
                        color="primary"
                        sx={{ mb: 0.5 }}
                      >
                        {goalData.value}
                      </Typography>
                    </Box>

                    {goalData.completed !== undefined && (
                      <Box sx={{ mt: 0.5 }}>
                        <LinearProgress
                          variant="determinate"
                          value={calculatedPercentage}
                          sx={{
                            height: 8,
                            borderRadius: 4,
                            backgroundColor: "rgba(0,0,0,0.1)",
                            "& .MuiLinearProgress-bar": {
                              backgroundColor: goalData.progressColor,
                            },
                          }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ mt: 0.5, textAlign: "right", fontSize: "0.9rem" }}
                        >
                          {calculatedPercentage}%
                        </Typography>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{
                            mt: 0.25,
                            display: "block",
                            textAlign: "right",
                            fontSize: "0.8rem",
                          }}
                        >
                          Completed: {goalData.completed}/{goalData.value}
                        </Typography>
                      </Box>
                    )}
                  </Paper>
                </Grid>
              );
            })}
          </Grid>
        </Box>

        {/* Goals Timeline Table */}
        {/* Goals Timeline Table */}
        <Box sx={{ mb: 8 }}>
          <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
            Goals Timeline
          </Typography>

          <TableContainer component={Paper} sx={{ boxShadow: 3, borderRadius: 2 }}>
            <Table>
              <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold' }}>Goal Name</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Goal Type</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Category</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Timeline</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {allEmployeeGoals && allEmployeeGoals.length > 0 ? (
                  allEmployeeGoals.map((goal) => {
                    // ✅ Parse category JSON safely
                    let categories = [];
                    try {
                      const parsed = JSON.parse(goal.catagore_json);
                      categories = Array.isArray(parsed) ? parsed : [];
                    } catch {
                      categories = [];
                    }

                    // ✅ Validate dates
                    const isValidStart = goal.start_date && new Date(goal.start_date).getFullYear() > 2000;
                    const isValidEnd = goal.end_date && new Date(goal.end_date).getFullYear() > 2000;

                    return (
                      <TableRow
                        key={goal.id}
                        hover
                        sx={{ cursor: 'pointer' }}
                        onClick={() => handleGoalsDetailsClick(goal.id)}
                      >
                        {/* Goal Title */}
                        <TableCell>{goal.title}</TableCell>

                        {/* Goal Type */}
                        <TableCell>
                          <Chip
                            label={goal.goal_type}
                            size="small"
                            color={goal.goal_type?.includes('Personal') ? 'primary' : 'secondary'}
                          />
                        </TableCell>

                        {/* Category */}
                        <TableCell>
                          {categories.length > 0 ? (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                              {categories.map((cat, index) => (
                                <Chip
                                  key={index}
                                  label={cat.category}
                                  size="small"
                                  variant="outlined"
                                />
                              ))}
                            </Box>
                          ) : (
                            'No category'
                          )}
                        </TableCell>

                        {/* Timeline */}
                        <TableCell sx={{ textAlign: 'center' }}>
                          {isValidStart && isValidEnd ? (
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, alignItems: 'center' }}>
                              <Chip
                                label={`Start: ${formatDate(goal.start_date)}`}
                                size="small"
                                variant="outlined"
                                sx={{ borderColor: '#6366F1', color: '#6366F1' }}
                              />
                              <Chip
                                label={`End: ${formatDate(goal.end_date)}`}
                                size="small"
                                variant="outlined"
                                sx={{ borderColor: '#EF4444', color: '#EF4444' }}
                              />
                            </Box>
                          ) : (
                            <Chip
                              label="No timeline"
                              size="small"
                              variant="outlined"
                              sx={{ borderColor: '#9CA3AF', color: '#9CA3AF' }}
                            />
                          )}
                        </TableCell>

                        {/* Status */}
                        <TableCell>
                          <Chip
                            label={goal.status}
                            size="small"
                            sx={{
                              fontWeight: 'bold',
                              backgroundColor: statusColors[goal.status] || '#e5e7eb',
                              color: statusTextColors[goal.status] || '#000'
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} sx={{ textAlign: 'center', py: 4 }}>
                      <Typography color="text.secondary">
                        No goals are added
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          {allEmployeeGoals && allEmployeeGoals.length > 0 && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                backgroundColor: '#f8fafc',
                borderTop: '1px solid #e2e8f0',
                p: 2,
                gap: 2
              }}
            >
              <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel>Rows per page</InputLabel>
                <Select
                  value={rowsPerPage}
                  onChange={handleRowsPerPageChange}
                  label="Rows per page"
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>

              <Pagination
                count={pagination.totalPages}
                page={pagination.currentPage}
                onChange={handlePaginationChange}
                color="primary"
              />
            </Box>
          )}
        </Box>

        <PerfomanceRatingsAndFeedBack />
      </motion.div>


      {/* Add goals dialog box */}
      <Dialog
        open={openRequestDialog}
        onClose={handleCloseRequestDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            backgroundImage: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
          }
        }}
      >
        <AddGoal
          onClose={handleCloseRequestDialog}
          onGoalAdded={() => getAllGoalsForEmployee({
            page: pagination.currentPage,
            limit: rowsPerPage
          })}
        />

      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {/* Goals details modal */}
      <GoalDetails
        isOpen={isGoalsDetailsModalOpen}
        onClose={() => setIsgoalsDetailsModalOpen(false)}
        selectedGoal={selectedGoal}
      />
      {/* <Modal
        open={isGoalsDetailsModalOpen}
        onClose={() => setIsgoalsDetailsModalOpen(false)}
       
      >
        <Box
          sx={{
            maxWidth: '80vw',
            maxHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            margin: 'auto',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            backdropFilter: 'blur(10px)',
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
            zIndex: "100"
          }}
        >

          {/* Scrollable Content */}
      {/* <Box sx={{ flex: 1, overflowY: 'auto', p: 2 }}>
            <GoalDetails selectedGoal={selectedGoal}/>
          </Box>

          {/* Fixed Footer */}
      {/* <Box sx={{ p: 2, borderTop: '1px solid #e0e0e0', textAlign: 'right' }}>
            <Button variant="outlined" color="primary" onClick={() => setIsgoalsDetailsModalOpen(false)}>
              CLOSE
            </Button>
          </Box>
        </Box>
      </Modal> */}
    </Box>


  )
}

export default EmployeeApparisals